import type { JournalWriteHistoryScope } from '@/lib/journalWritePath';
import { journalWriteNoteMatchesPractitioner } from '@/lib/journalWritePractitionerFilter';

/** Fields the open Tidligere notater list uses to decide what is shown. */
export type JournalWriteHistoryListEntry = {
  discarded_at: string | null;
  appointment_id: string | null;
  clinician_id: string | null;
  author_name: string | null;
  title: string | null;
  content_md: string;
};

export type JournalWriteHistoryListInput = {
  scope: JournalWriteHistoryScope;
  courseAppointmentIds: ReadonlySet<string>;
  /** Empty string is Alle behandlere. `employees` is Alle medarbejdere (the write-view default). */
  practitionerId: string;
  practitionerIds: ReadonlySet<string>;
  activeMemberIds: ReadonlySet<string>;
  search: string;
  appointmentById?: ReadonlyMap<string, { clinician_name?: string | null }>;
};

/**
 * Notes the open panel lists. The closed rail must use this same result.
 * Forløb, the practitioner filter, and search all apply. Journal write
 * starts the practitioner filter on Alle medarbejdere.
 */
export function filterJournalWriteHistoryEntries<T extends JournalWriteHistoryListEntry>(
  entries: readonly T[],
  input: JournalWriteHistoryListInput,
): T[] {
  const query = input.search.trim().toLowerCase();
  return entries.filter((entry) => {
    if (entry.discarded_at) return false;
    if (input.scope === 'course' && input.courseAppointmentIds.size > 0) {
      if (!entry.appointment_id || !input.courseAppointmentIds.has(entry.appointment_id)) {
        return false;
      }
    }
    const appointmentName = entry.appointment_id
      ? input.appointmentById?.get(entry.appointment_id)?.clinician_name
      : undefined;
    const name = appointmentName || entry.author_name || '';
    if (
      !journalWriteNoteMatchesPractitioner({
        clinicianId: entry.clinician_id,
        authorName: name,
        filterId: input.practitionerId,
        practitionerIds: input.practitionerIds,
        activeMemberIds: input.activeMemberIds,
      })
    ) {
      return false;
    }
    if (!query) return true;
    const hay = `${entry.title ?? ''} ${entry.content_md} ${entry.author_name ?? ''}`.toLowerCase();
    return hay.includes(query);
  });
}
